export const URL_ANIO = "/Impuesto/WebService/ImpuestoWebService.asmx/BuscarAnios";
export const URL_MES = "/Impuesto/WebService/ImpuestoWebService.asmx/BuscarMeses";
export const URL_REPORTE_606 = "/Impuesto/WebService/ImpuestoWebService.asmx/Reporte606";
export const URL_REPORTE_607 = "/Impuesto/WebService/ImpuestoWebService.asmx/Reporte607";

export class ImpuestoReporteService {
  static consultar(url, opciones) {
    return new Promise(function (resolve, reject) {
      const where = opciones ? { where: { ...opciones } } : null;
      Citrus.AJAX.getJSON(url, where, function (respuesta) {
        var datos = $.parseJSON(respuesta.d);

        if (
          datos &&
          datos["Mensaje"] !== undefined &&
          datos["Detalle"] !== undefined &&
          datos["Interno"] !== undefined
        ) {
          reject(datos);
        }
        resolve(datos);
      });
    });
  }

  static consultarAnios() {
    return this.consultar(URL_ANIO).then((res) => res?.Resultados);
  }

  static consultarMeses() {
    return this.consultar(URL_MES).then((res) => res?.Resultados);
  }

  static consultarReporte606(where) {
    return this.consultar(URL_REPORTE_606, {
      ...where,
    }).then((res) => {
      return res;
    });
  }

  static consultarReporte607(where) {
    return this.consultar(URL_REPORTE_607, { ...where }).then((res) => {
      console.log(res);
      return res;
    });
  }
}
